import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { ResetPasswordPageComponent } from '@popup/multichain/pages/sign-in/reset-password/reset-password.component';
import { SignInComponent } from '@popup/multichain/pages/sign-in/sign-in/sign-in.component';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PageTitleComponent } from 'src/common-ui/page-title/page-title.component';
import { Screen } from 'src/reference-data/screen.enum';
const SignInRouter = ({ currentPage, navigateTo, titleProperties, hasTitle, setIsUnlocked, }) => {
    useEffect(() => {
        // // console.log('[SignInRouter] Navigating to SIGN_IN_PAGE');
        navigateTo(Screen.SIGN_IN_PAGE);
    }, []);
    const renderSignInPage = (page) => {
        switch (page) {
            case Screen.RESET_PASSWORD_PAGE:
                return React.createElement(ResetPasswordPageComponent, null);
            default:
                return React.createElement(SignInComponent, { setIsUnlocked: setIsUnlocked });
        }
    };
    return (React.createElement("div", { className: "sign-in-router-page", style: {
            width: '100%',
            height: '100%',
            maxWidth: '400px',
            maxHeight: '600px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            boxSizing: 'border-box',
        } },
        hasTitle && (React.createElement(PageTitleComponent, { title: titleProperties.title, titleParams: titleProperties.titleParams, skipTitleTranslation: titleProperties.skipTitleTranslation, isBackButtonEnabled: titleProperties.isBackButtonEnabled, isCloseButtonDisabled: titleProperties.isCloseButtonDisabled, style: {
                width: '100%',
                height: '70px',
                flexShrink: 0,
            } })),
        React.createElement("div", { className: "page-content", style: {
                width: '100%',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
            } }, renderSignInPage(currentPage))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        currentPage: state.navigation.stack[0]
            ? state.navigation.stack[0].currentPage
            : Screen.UNDEFINED,
        hasTitle: ((_a = state.titleContainer) === null || _a === void 0 ? void 0 : _a.title.length) > 0,
        titleProperties: state.titleContainer,
    };
};
const connector = connect(mapStateToProps, { navigateTo });
export const SignInRouterComponent = connector(SignInRouter);
